import { createBrowserRouter, RouterProvider, ScrollRestoration, Outlet } from 'react-router'
import { AuthProvider } from '@/lib/auth-context'
import { ScopeProvider } from '@/lib/scope-context'
import { ExpenseTypeProvider } from '@/lib/expense-type-context'
import { PaidByProvider } from '@/lib/paid-by-context'
import { ErrorBoundary } from '@/components/error-boundary'
import MainLayout from '@/layouts/MainLayout'
import LoginPage from '@/pages/LoginPage'
import AuthCallbackPage from '@/pages/AuthCallbackPage'
import HomePage from '@/pages/HomePage'
import TransactionsPage from '@/pages/TransactionsPage'
import NewTransactionPage from '@/pages/NewTransactionPage'
import TransactionDetailPage from '@/pages/TransactionDetailPage'
import TransactionEditPage from '@/pages/TransactionEditPage'
import ReportPage from '@/pages/ReportPage'
import SettingsPage from '@/pages/SettingsPage'
import CategoriesPage from '@/pages/CategoriesPage'
import RecurringPage from '@/pages/RecurringPage'
import AccountPage from '@/pages/AccountPage'
import ApiUsagePage from '@/pages/ApiUsagePage'
import ReceiptPage from '@/pages/ReceiptPage'
import TagsPage from '@/pages/TagsPage'
import TagTransactionsPage from '@/pages/TagTransactionsPage'
import PaymentMethodsPage from '@/pages/PaymentMethodsPage'
import PaymentMethodDetailPage from '@/pages/PaymentMethodDetailPage'
import PaymentMethodEditPage from '@/pages/PaymentMethodEditPage'

function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  )
}

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/auth/callback', element: <AuthCallbackPage /> },
      {
        element: <AuthProvider><ScopeProvider><ExpenseTypeProvider><PaidByProvider><MainLayout /></PaidByProvider></ExpenseTypeProvider></ScopeProvider></AuthProvider>,
        children: [
          { index: true, element: <ErrorBoundary><HomePage /></ErrorBoundary> },
          { path: 'transactions', element: <ErrorBoundary><TransactionsPage /></ErrorBoundary> },
          { path: 'transactions/new', element: <ErrorBoundary><NewTransactionPage /></ErrorBoundary> },
          { path: 'receipt', element: <ErrorBoundary><ReceiptPage /></ErrorBoundary> },
          { path: 'transactions/:id', element: <ErrorBoundary><TransactionDetailPage /></ErrorBoundary> },
          { path: 'transactions/:id/edit', element: <ErrorBoundary><TransactionEditPage /></ErrorBoundary> },
          { path: 'report', element: <ErrorBoundary><ReportPage /></ErrorBoundary> },
          { path: 'settings', element: <ErrorBoundary><SettingsPage /></ErrorBoundary> },
          { path: 'settings/categories', element: <ErrorBoundary><CategoriesPage /></ErrorBoundary> },
          { path: 'tags', element: <ErrorBoundary><TagsPage /></ErrorBoundary> },
          { path: 'tags/:id', element: <ErrorBoundary><TagTransactionsPage /></ErrorBoundary> },
          { path: 'recurring', element: <ErrorBoundary><RecurringPage /></ErrorBoundary> },
          { path: 'settings/account', element: <ErrorBoundary><AccountPage /></ErrorBoundary> },
          { path: 'settings/api-usage', element: <ErrorBoundary><ApiUsagePage /></ErrorBoundary> },
          { path: 'settings/payment-methods', element: <ErrorBoundary><PaymentMethodsPage /></ErrorBoundary> },
          { path: 'settings/payment-methods/new', element: <ErrorBoundary><PaymentMethodEditPage /></ErrorBoundary> },
          { path: 'settings/payment-methods/:id', element: <ErrorBoundary><PaymentMethodDetailPage /></ErrorBoundary> },
          { path: 'settings/payment-methods/:id/edit', element: <ErrorBoundary><PaymentMethodEditPage /></ErrorBoundary> },
        ],
      },
    ],
  },
])

export default function App() {
  return <RouterProvider router={router} />
}
